import { Suspense } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import ProtectedPageLayout from '@layouts/PageLayout/ProtectedPageLayout'
import PageNotFound from '@layouts/PageNotFound/PageNotFound'
import { useAuth } from '@config/auth/context/authProvider'
import LocationChangeConfirmationModal from '@/components/Modal/LocationChangeConfirmationModal/LocationChangeConfirmationModal'
import { useFormDirtyStore } from '@/store/useFormDirtyStore'
import TablesList from '@/layouts/TablesList/TablesList'
import LoadingPage from '@/layouts/LoadingPage/LoadingPage'
import OrderPage from '@/layouts/OrderPage/OrderPage'
import DishConfiguration from '@/layouts/DishConfiguration/DishConfiguration'
import ServeOrder from '@/layouts/ServeOrder/ServeOrder'

type RestrictAccessProps = {
  children: React.ReactNode
}

function RestrictAccess({ children }: RestrictAccessProps) {
  const { userLoggedIn } = useAuth()
  const restaurantId = localStorage.getItem('restaurantId')

  return userLoggedIn !== null && userLoggedIn === true && restaurantId ? (
    <>{children}</>
  ) : (
    <Navigate to="/login" replace />
  )
}

function App() {
  const isDirty = useFormDirtyStore(s => s.isDirty)

  return (
    <RestrictAccess>
      <ProtectedPageLayout>
        <Suspense fallback={<LoadingPage />}>
          <Outlet />
          <LocationChangeConfirmationModal when={isDirty} />
        </Suspense>
      </ProtectedPageLayout>
    </RestrictAccess>
  )
}

export const protectedRoutes = [
  {
    path: '/',
    element: <App />,
    children: [
      {
        index: true,
        element: <TablesList />
      },
      {
        path: '/tables-list',
        element: <TablesList />
      },
      {
        path: '/table/:tableId',
        element: <OrderPage />
      },
      {
        path: '/table/:tableId/new-order/:dishId',
        element: <DishConfiguration />
      },
      {
        path: '/table/:tableId/serve',
        element: <ServeOrder />
      }
    ]
  },
  { path: '/not-found', element: <PageNotFound /> },
  { path: '*', element: <Navigate to="/not-found" replace /> }
]
